<template>
  <enb-seo-card comp="SeoFrenteLoja" label="Frente de loja"/>
</template>

<script>
import EnbSeoCard from './EnbSeoCard'
export default {
  name: 'EnbSeoFrenteLoja',
  components: { EnbSeoCard }
}
</script>
